(function () {
    'use strict';

    angular
        .module('franchisee-portal.services')
        .service('VideoService', VideoService)

    /** @ngInject */
    function VideoService(HttpService) {
        const VideoService = {
            getAllByParameters: getAllByParameters,
            getByUrl: getByUrl,
            getCommentsByParameters: getCommentsByParameters,
            postAccessLog: postAccessLog,
            postComment: postComment
        }

        return VideoService;

        function getAllByParameters(params, personId) {
            return HttpService.get(`/videos/parameters/${personId}`, {
                params
            });
        }

        function getByUrl(url, personId, responsibilityId) {
            return HttpService.get(`/videos/${personId}/${responsibilityId}/${url}`)
        }

        function getCommentsByParameters(params) {
            return HttpService.get('/videos/comments', {
                params
            });
        }

        function postAccessLog(accessLogData) {
            return HttpService.post('/videos/access-log', accessLogData);
        }

        function postComment(commentData) {
            return HttpService.post('/videos/comments', commentData);
        }
    }
}());